/**
 * The tab of a measure's pane that holds its products — the links it already
 * has and the ones the matcher suggests.
 *
 * Shared because three places name it and none of them may drift: the pane
 * declares the tab, the dashboard links into it, and a notification about a
 * suggestion stores an address that has to reach it. A literal per place is
 * how a link comes to land on the wrong tab of the right screen.
 */
export const MEASURE_PRODUCTS_PANE = 'products'
